import { render, staticRenderFns } from "./ProfessionsChart.vue?vue&type=template&id=4736eff4"
import script from "./ProfessionsChart.vue?vue&type=script&lang=js"
export * from "./ProfessionsChart.vue?vue&type=script&lang=js"
import style0 from "./ProfessionsChart.vue?vue&type=style&index=0&id=4736eff4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports